import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  loading: false,
  filterLoading: false,
  success: false,
  selectedRecord: null,
  company: [],
  appraisalType: [],
  levelGroup: [],
  parentLevel: [],
  positionGroup: [],
  filterCompany: [],
  filterLevel: [],
  filterActive: [],
  filterParentLevel: [],
  imported: false,
  errorMessage: null,
  modalLoadingQueue: []
}

const fetchLevelStart = (state, action) => {
  return { ...state, loading: true, modalLoadingQueue: [...state.modalLoadingQueue, 'fetchLevel'] }
}

const fetchLevelSuccess = (state, action) => {
  let { records } = action
  records = records.map(res => {
    let data = res
    return {
      ...data,
      company_name: data?.company?.company_name,
      parent_name: data?.parent?.level_name,
      appraisal_type_name: data?.appraisal_type?.value_list_name
    }
  })

  return {
    ...state,
    modalLoadingQueue: state.modalLoadingQueue.filter(item => item !== 'fetchLevel'),
    loading: false,
    pagination: action.pagination,
    records
  }
}

const fetchLevelFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    modalLoadingQueue: state.modalLoadingQueue.filter(item => item !== 'fetchLevel'),
    errorMessage: action.errorMessage
  }
}

const fetchLevelByIdSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    selectedRecord: action.recordData,
    modalLoadingQueue: state.modalLoadingQueue.filter(item => item !== 'fetchLevel')
  }
}

const clearSelectedLevelRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: { is_active: true },
    success: false
  }
}

const createLevelStart = (state, action) => {
  return { ...state, loading: true }
}

const createLevelSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const createLevelFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const updateLevelStart = (state, action) => {
  return { ...state, loading: true }
}

const updateLevelSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const updateLevelFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const deleteLevelStart = (state, action) => {
  return { ...state, loading: true }
}

const deleteLevelSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const deleteLevelFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const fetchCompanyStart = (state, action) => {
  return {
    ...state,
    loading: true,
    modalLoadingQueue: [...state.modalLoadingQueue, 'fetchCompany']
  }
}

const fetchCompanySuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    company: action.data,
    modalLoadingQueue: state.modalLoadingQueue.filter(item => item !== 'fetchCompany')
  }
}

const fetchCompanyFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage,
    modalLoadingQueue: state.modalLoadingQueue.filter(item => item !== 'fetchCompany')
  }
}

const fetchAppraisalTypeStart = (state, action) => {
  return {
    ...state,
    loading: true,
    modalLoadingQueue: [...state.modalLoadingQueue, 'fetchAppraisalType']
  }
}

const fetchAppraisalTypeSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    appraisalType: action.data,
    modalLoadingQueue: state.modalLoadingQueue.filter(item => item !== 'fetchAppraisalType')
  }
}

const fetchAppraisalTypeFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage,
    modalLoadingQueue: state.modalLoadingQueue.filter(item => item !== 'fetchAppraisalType')
  }
}

const fetchParentLevelStart = (state, action) => {
  return {
    ...state,
    loading: true,
    modalLoadingQueue: [...state.modalLoadingQueue, 'fetchParentLevel']
  }
}

const fetchParentLevelSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    parentLevel: action.data,
    modalLoadingQueue: state.modalLoadingQueue.filter(item => item !== 'fetchParentLevel')
  }
}

const fetchParentLevelFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage,
    modalLoadingQueue: state.modalLoadingQueue.filter(item => item !== 'fetchParentLevel')
  }
}

const fetchPositionGroupStart = (state, action) => {
  return {
    ...state,
    loading: true,
    modalLoadingQueue: [...state.modalLoadingQueue, 'fetchPositionGroup']
  }
}

const fetchPositionGroupSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    positionGroup: action.data,
    modalLoadingQueue: state.modalLoadingQueue.filter(item => item !== 'fetchPositionGroup')
  }
}

const fetchPositionGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage,
    modalLoadingQueue: state.modalLoadingQueue.filter(item => item !== 'fetchPositionGroup')
  }
}

const fetchLevelFilterCompanyStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchLevelFilterCompanySuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterCompany: action.data
  }
}

const fetchLevelFilterCompanyFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const fetchLevelGroupStart = (state, action) => {
  return {
    ...state,
    loading: true,
    modalLoadingQueue: [...state.modalLoadingQueue, 'fetchLevelGroup']
  }
}

const fetchLevelGroupSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    levelGroup: action.data,
    modalLoadingQueue: state.modalLoadingQueue.filter(item => item !== 'fetchLevelGroup')
  }
}

const fetchLevelGroupFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage,
    modalLoadingQueue: state.modalLoadingQueue.filter(item => item !== 'fetchLevelGroup')
  }
}

const fetchLevelFilterLevelStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchLevelFilterLevelSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterLevel: action.data
  }
}

const fetchLevelFilterLevelFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const fetchLevelFilterParentLevelStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchLevelFilterParentLevelSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterParentLevel: action.data
  }
}

const fetchLevelFilterParentLevelFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const fetchLevelFilterActiveStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchLevelFilterActiveSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterActive: action.data
  }
}

const fetchLevelFilterActiveFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const importLevelStart = (state, action) => {
  return {
    ...state,
    importLoading: true,
    imported: false
  }
}

const importLevelSuccess = (state, action) => {
  return {
    ...state,
    importLoading: false,
    imported: true
  }
}

const importLevelFailed = (state, action) => {
  return {
    ...state,
    importLoading: false,
    imported: false
  }
}

const exportLevelStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const exportLevelSuccess = (state, action) => {
  return {
    ...state,
    loading: false
  }
}

const exportLevelFailed = (state, action) => {
  return {
    ...state,
    loading: false
  }
}

const downloadLevelTemplateStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const downloadLevelTemplateSuccess = (state, action) => {
  return {
    ...state,
    loading: false
  }
}

const downloadLevelTemplateFailed = (state, action) => {
  return {
    ...state,
    loading: false
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_LEVEL_START:
      return fetchLevelStart(state, action)
    case actionTypes.FETCH_LEVEL_SUCCESS:
      return fetchLevelSuccess(state, action)
    case actionTypes.FETCH_LEVEL_BY_ID_SUCCESS:
      return fetchLevelByIdSuccess(state, action)
    case actionTypes.FETCH_LEVEL_FAILED:
      return fetchLevelFailed(state, action)
    case actionTypes.CLEAR_SELECTED_LEVEL_RECORD:
      return clearSelectedLevelRecord(state, action)
    case actionTypes.CREATE_LEVEL_START:
      return createLevelStart(state, action)
    case actionTypes.CREATE_LEVEL_SUCCESS:
      return createLevelSuccess(state, action)
    case actionTypes.CREATE_LEVEL_FAILED:
      return createLevelFailed(state, action)
    case actionTypes.UPDATE_LEVEL_START:
      return updateLevelStart(state, action)
    case actionTypes.UPDATE_LEVEL_SUCCESS:
      return updateLevelSuccess(state, action)
    case actionTypes.UPDATE_LEVEL_FAILED:
      return updateLevelFailed(state, action)
    case actionTypes.DELETE_LEVEL_START:
      return deleteLevelStart(state, action)
    case actionTypes.DELETE_LEVEL_SUCCESS:
      return deleteLevelSuccess(state, action)
    case actionTypes.DELETE_LEVEL_FAILED:
      return deleteLevelFailed(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanySuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyFailed(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_START:
      return fetchLevelGroupStart(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_SUCCESS:
      return fetchLevelGroupSuccess(state, action)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FAILED:
      return fetchLevelGroupFailed(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_START:
      return fetchAppraisalTypeStart(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_SUCCESS:
      return fetchAppraisalTypeSuccess(state, action)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FAILED:
      return fetchAppraisalTypeFailed(state, action)
    case actionTypes.FETCH_PARENT_LEVEL_OPTIONS_START:
      return fetchParentLevelStart(state, action)
    case actionTypes.FETCH_PARENT_LEVEL_OPTIONS_SUCCESS:
      return fetchParentLevelSuccess(state, action)
    case actionTypes.FETCH_PARENT_LEVEL_OPTIONS_FAILED:
      return fetchPositionGroupFailed(state, action)
    case actionTypes.FETCH_POSITION_GROUP_OPTIONS_START:
      return fetchPositionGroupStart(state, action)
    case actionTypes.FETCH_POSITION_GROUP_OPTIONS_SUCCESS:
      return fetchPositionGroupSuccess(state, action)
    case actionTypes.FETCH_POSITION_GROUP_OPTIONS_FAILED:
      return fetchParentLevelFailed(state, action)
    case actionTypes.FETCH_LEVEL_FILTER_COMPANY_START:
      return fetchLevelFilterCompanyStart(state, action)
    case actionTypes.FETCH_LEVEL_FILTER_COMPANY_SUCCESS:
      return fetchLevelFilterCompanySuccess(state, action)
    case actionTypes.FETCH_LEVEL_FILTER_COMPANY_FAILED:
      return fetchLevelFilterCompanyFailed(state, action)
    case actionTypes.FETCH_LEVEL_FILTER_LEVEL_START:
      return fetchLevelFilterLevelStart(state, action)
    case actionTypes.FETCH_LEVEL_FILTER_LEVEL_SUCCESS:
      return fetchLevelFilterLevelSuccess(state, action)
    case actionTypes.FETCH_LEVEL_FILTER_LEVEL_FAILED:
      return fetchLevelFilterLevelFailed(state, action)
    case actionTypes.FETCH_LEVEL_FILTER_PARENT_LEVEL_START:
      return fetchLevelFilterParentLevelStart(state, action)
    case actionTypes.FETCH_LEVEL_FILTER_PARENT_LEVEL_SUCCESS:
      return fetchLevelFilterParentLevelSuccess(state, action)
    case actionTypes.FETCH_LEVEL_FILTER_PARENT_LEVEL_FAILED:
      return fetchLevelFilterParentLevelFailed(state, action)
    case actionTypes.FETCH_LEVEL_FILTER_ACTIVE_START:
      return fetchLevelFilterActiveStart(state, action)
    case actionTypes.FETCH_LEVEL_FILTER_ACTIVE_SUCCESS:
      return fetchLevelFilterActiveSuccess(state, action)
    case actionTypes.FETCH_LEVEL_FILTER_ACTIVE_FAILED:
      return fetchLevelFilterActiveFailed(state, action)
    case actionTypes.IMPORT_LEVEL_START:
      return importLevelStart(state, action)
    case actionTypes.IMPORT_LEVEL_SUCCESS:
      return importLevelSuccess(state, action)
    case actionTypes.IMPORT_LEVEL_FAILED:
      return importLevelFailed(state, action)
    case actionTypes.EXPORT_LEVEL_START:
      return exportLevelStart(state, action)
    case actionTypes.EXPORT_LEVEL_SUCCESS:
      return exportLevelSuccess(state, action)
    case actionTypes.EXPORT_LEVEL_FAILED:
      return exportLevelFailed(state, action)
    case actionTypes.DOWNLOAD_LEVEL_TEMPLATE_START:
      return downloadLevelTemplateStart(state, action)
    case actionTypes.DOWNLOAD_LEVEL_TEMPLATE_SUCCESS:
      return downloadLevelTemplateSuccess(state, action)
    case actionTypes.DOWNLOAD_LEVEL_TEMPLATE_FAILED:
      return downloadLevelTemplateFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
